import React, { useState, useEffect } from 'react';
import { recordService } from '../services';
import PRCard from '../components/PRCard';
import toast from 'react-hot-toast';

const Records = () => {
  const [records, setRecords] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRecords();
  }, []);

  const loadRecords = async () => {
    try {
      const response = await recordService.getAll();
      setRecords(response.data.data);
    } catch (error) {
      console.error('Error loading records:', error);
      toast.error('Error al cargar récords personales');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const recordsArray = Object.entries(records);

  return (
    <div className="container mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Récords Personales 🏆</h1>
        <p className="text-gray-400">
          Tus mejores marcas en cada ejercicio
        </p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-gray-800 rounded-lg p-4">
          <div className="text-3xl mb-2">💪</div>
          <div className="text-2xl font-bold">
            {recordsArray.length}
          </div>
          <div className="text-sm text-gray-400">Ejercicios con Récords</div>
        </div>
        
        <div className="bg-gray-800 rounded-lg p-4">
          <div className="text-3xl mb-2">🎯</div>
          <div className="text-2xl font-bold">
            {recordsArray.reduce((sum, [, recs]) => sum + recs.length, 0)}
          </div>
          <div className="text-sm text-gray-400">Total de Récords</div>
        </div>
        
        <div className="bg-gray-800 rounded-lg p-4">
          <div className="text-3xl mb-2">📈</div>
          <div className="text-2xl font-bold">
            {recordsArray.filter(([, recs]) => {
              const lastRecord = recs[0];
              const today = new Date();
              const recordDate = new Date(lastRecord?.achieved_date);
              const diffDays = Math.floor((today - recordDate) / (1000 * 60 * 60 * 24));
              return diffDays <= 7;
            }).length}
          </div>
          <div className="text-sm text-gray-400">Récords Esta Semana</div>
        </div>
      </div>

      {/* Records by Exercise */}
      {recordsArray.length === 0 ? (
        <div className="text-center py-12 bg-gray-800 rounded-lg">
          <div className="text-6xl mb-4">🏆</div>
          <h3 className="text-xl font-semibold mb-2">Sin Récords Aún</h3>
          <p className="text-gray-400">
            Completa tu primer entrenamiento para establecer récords
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {recordsArray.map(([exerciseName, exerciseRecords]) => (
            <div key={exerciseName} className="bg-gray-800 rounded-lg p-4">
              <h2 className="text-xl font-bold mb-4">{exerciseName}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {exerciseRecords.map((record) => (
                  <PRCard 
                    key={`${record.id}-${record.record_type}`}
                    record={record} 
                    exercise={{ name: exerciseName }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Records;
